/* nx-motion-ba.js — плъзгачът „Преди / След": клавиатура, скрол с пръст и еднократна подсказка.
   Собственик: C — интеракции.

   devices.js строи .ba при DOMContentLoaded и пази позицията в CSS променливата --pos
   (в %, от 4 до 96) направо върху .ba. Тук поемаме натискането още в capture фазата на
   родителя [data-ba], преди слушателите на devices.js, и сами пишем същото --pos:
   · мишка/писалка — както досега: натискаш и дърпаш;
   · пръст — чакаме посоката: хоризонтално движение мести дръжката, вертикалното е скрол
     на страницата (touch-action: pan-y в CSS на секцията); почукване слага дръжката там;
   · клавиатура — role="slider", ←/→ (и ↑/↓) по 5 %, Home/End до краищата.
   Подсказка: веднъж, когато плъзгачът стигне top 65%, дръжката минава 50 → 18 → 82 → 50
   за 1,8 s. Първото натискане или клавиш я спира. При prefers-reduced-motion — без нея. */
(function () {
  if (window.__nxBa) return;
  window.__nxBa = true;
  if (!window.NX) return;

  var MIN = 4, MAX = 96, STEP = 5, LOCK = 8;   // LOCK — px, преди да решим посоката на пръста

  function clamp(p) { return Math.max(MIN, Math.min(MAX, p)); }

  // нова позиция за клавиш или null, ако клавишът не е наш
  function keyTo(key, cur) {
    switch (key) {
      case 'ArrowLeft': case 'ArrowDown': case 'Left': case 'Down': return clamp(cur - STEP);
      case 'ArrowRight': case 'ArrowUp': case 'Right': case 'Up': return clamp(cur + STEP);
      case 'Home': return MIN;
      case 'End': return MAX;
    }
    return null;
  }

  // '' — още не е ясно; 'x' — плъзгач; 'y' — скрол на страницата
  function axis(dx, dy) {
    var ax = Math.abs(dx), ay = Math.abs(dy);
    if (ax < LOCK && ay < LOCK) return '';
    return ax > ay ? 'x' : 'y';
  }

  function setup(root, ba, flags) {
    var label = root.getAttribute('data-ba-label') || 'Плъзгач: преди и след';
    var hint = null, st = null, touched = false, g = null;

    function read() {
      var v = parseFloat(ba.style.getPropertyValue('--pos'));
      return isNaN(v) ? 50 : v;
    }
    function apply(p) {
      p = clamp(p);
      var r = Math.round(p);
      ba.style.setProperty('--pos', p + '%');
      ba.setAttribute('aria-valuenow', String(r));
      ba.setAttribute('aria-valuetext', 'Преди ' + r + ' %, след ' + (100 - r) + ' %');
    }
    function fromX(x) {
      var b = ba.getBoundingClientRect();
      return b.width ? (x - b.left) / b.width * 100 : read();
    }
    function stopHint() {
      touched = true;
      if (st) { st.kill(); st = null; }
      if (hint) { hint.kill(); hint = null; }
    }

    ba.setAttribute('role', 'slider');
    ba.setAttribute('tabindex', '0');
    ba.setAttribute('aria-valuemin', String(MIN));
    ba.setAttribute('aria-valuemax', String(MAX));
    ba.setAttribute('aria-label', label);
    apply(read());

    function onDown(e) {
      if (!ba.contains(e.target)) return;
      e.stopPropagation();   // devices.js не бива да скача при всяко докосване
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      stopHint();
      g = { id: e.pointerId, x: e.clientX, y: e.clientY, touch: e.pointerType === 'touch', on: false };
      if (!g.touch) {
        g.on = true;
        try { ba.setPointerCapture(e.pointerId); } catch (_) {}
        apply(fromX(e.clientX));
      }
    }
    function onMove(e) {
      if (!g || e.pointerId !== g.id) return;
      if (!g.on) {
        var a = axis(e.clientX - g.x, e.clientY - g.y);
        if (!a) return;
        if (a === 'y') { g = null; return; }   // вертикално — страницата скролва, ние не пречим
        g.on = true;
        try { ba.setPointerCapture(e.pointerId); } catch (_) {}
      }
      apply(fromX(e.clientX));
    }
    function onUp(e) {
      if (!g || e.pointerId !== g.id) return;
      if (!g.on && g.touch) apply(fromX(e.clientX));   // почукване
      g = null;
    }
    function onCancel() { g = null; }
    function onKey(e) {
      var p = keyTo(e.key, read());
      if (p === null) return;
      e.preventDefault();
      stopHint();
      apply(p);
    }

    root.addEventListener('pointerdown', onDown, { capture: true, passive: true });
    ba.addEventListener('pointermove', onMove, { passive: true });
    ba.addEventListener('pointerup', onUp, { passive: true });
    ba.addEventListener('pointercancel', onCancel, { passive: true });
    ba.addEventListener('keydown', onKey);

    if (flags.motion && window.gsap && window.ScrollTrigger) {
      var o = { p: 50 };
      var upd = function () { apply(o.p); };
      hint = gsap.timeline({ paused: true, defaults: { ease: 'power2.inOut', onUpdate: upd },
                             onComplete: function () { hint = null; } })
        .to(o, { p: 18, duration: 0.45 })
        .to(o, { p: 82, duration: 0.9 })
        .to(o, { p: 50, duration: 0.45 });
      st = ScrollTrigger.create({
        trigger: ba, start: 'top 65%', once: true,
        onEnter: function () {
          st = null;
          if (touched || !hint) return;
          o.p = read();
          hint.play();
        }
      });
    }

    return function () {
      var mid = !!hint && hint.isActive && hint.isActive();
      if (st) { st.kill(); st = null; }
      if (hint) { hint.kill(); hint = null; }
      if (mid && !touched) apply(50);   // прекъсната подсказка — връщаме дръжката в средата
      g = null;
      root.removeEventListener('pointerdown', onDown, { capture: true, passive: true });
      ba.removeEventListener('pointermove', onMove, { passive: true });
      ba.removeEventListener('pointerup', onUp, { passive: true });
      ba.removeEventListener('pointercancel', onCancel, { passive: true });
      ba.removeEventListener('keydown', onKey);
    };
  }

  // регистрираме родителя: .ba още го няма, когато ядрото тръгне — devices.js го строи след него
  NX.register('ba', '[data-ba]', function (root, flags) {
    flags = flags || NX.flags || {};
    var off = null, mo = null;
    var ba = root.querySelector('.ba');
    if (ba) off = setup(root, ba, flags);
    else if ('MutationObserver' in window) {
      mo = new MutationObserver(function () {
        var b = root.querySelector('.ba');
        if (!b) return;
        mo.disconnect(); mo = null;
        off = setup(root, b, flags);
      });
      mo.observe(root, { childList: true });
    }
    return function () {
      if (mo) { mo.disconnect(); mo = null; }
      if (off) { off(); off = null; }
    };
  });
})();
